module.exports = __webpack_public_path__ + "static/media/ico-floating-home.01e25aa0.svg";